import React from 'react';
import { Button } from 'react-bootstrap';
import AuthService from '../services/auth.service';
import '../content/css/TrialComponents.css';

const buttonClicked = () => {
    window.location.href = 'https://www.legly.io/pricing/monthly-subscription';
}

const getFreeReviewsLeftText = () => {
    let reviewsLeft = new AuthService().getFreeReviewsLeft();
    if (reviewsLeft > 1) return `only ${reviewsLeft} uploads`;
    else if (reviewsLeft == 1) return `only ${reviewsLeft} upload`;
    else if (reviewsLeft == 0) return `no uploads`;
}

export const TrialBanner = () => (
    <div className="trial-banner">
        <div>
            <div className="text">
                <div className="black">You are using a free account with {getFreeReviewsLeftText()} left.</div>
                <div className="black">Every 90 days you will be given 2 new free uploads.</div>
                <div className="purple" onClick={buttonClicked}>Upgrade for unlimited uploads today!</div>
            </div>
            <Button onClick={buttonClicked}>Get Unlimited Access</Button>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/TrialBanner.js